// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IUpdateContactPreferencesModel {
    static getAttributeTypeMap() {
        return IUpdateContactPreferencesModel.attributeTypeMap;
    }
}
IUpdateContactPreferencesModel.discriminator = undefined;
IUpdateContactPreferencesModel.additionalProperties = false;
IUpdateContactPreferencesModel.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "contactPreferences",
        "baseName": "contactPreferences",
        "type": ""
    },
];
//# sourceMappingURL=iUpdateContactPreferencesModel.js.map